import { RootState } from 'reducers';

export const root = (state: RootState) => state.app;

export const tokensLastUpdate = (state: RootState) => root(state).tokensTouched;
export const isAuthenticated = (state: RootState) => ({
  isAuthenticated: !!root(state).accessToken,
});
export const version = (state: RootState) => root(state).version;
export const metadataSelector = (state: RootState) => root(state).metadata;
export const languageSelector = (state: RootState) => root(state).language;
export const hrefSelector = (state: RootState) => root(state).href;
